/** Utils for interacting with data layer objects */
export const useTracking = () => {
  /** wrapper around window._mfq.push() */
  const mouseFlowPush = (toPush: (string | boolean)[]): void => {
    if (import.meta.server || !window || !window._mfq) return;
    window._mfq = window._mfq || [];
    window._mfq.push(toPush);
  };

  /** safely wrappers around window.dataLayer */
  const dataLayerPush = (data: { [key: string]: string; event: string }) => {
    if (import.meta.server || !window || !window.wwwGaIsReadyPromise) return;

    window.ptcDebug = window.ptcDebug || {};
    window.ptcDebug.dataLayerPushes = window.ptcDebug.dataLayerPushes || [];
    window.ptcDebug.dataLayerPushes.push(data);

    window.wwwGaIsReadyPromise.then(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    });
  };

  return { mouseFlowPush, dataLayerPush };
};
